import React from 'react'
import Sortable from 'react-sortablejs'

import { Field, FieldArray } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo'
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faGripLines } from '@fortawesome/pro-regular-svg-icons/faGripLines'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'

import { Textarea, File, SortableRow } from '@peracto/peracto-ui'
import last from 'lodash/last'

const ResourceIcon = ({ type, src = '', testId }) => {
    switch (type) {
        case 'main_image':
        case 'secondary_image':
            return <img src={src} style={{ width: '100%' }} title={src} data-testid={testId} />
        case 'video':
            return <FontAwesomeIcon icon={faVideo} title={src} />
        default:
            return <FontAwesomeIcon icon={faFile} title={src} />
    }
}

const Resources = ({ groupLabel = '', group }) => {
    const isSecondaryImage = group === 'secondary_image'
    return (
        <Field name={`categoryResources.${group}`}>
            {({ field, form }) => (
                <>
                    <FieldArray name={field.name}>
                        {({ push, remove }) => (
                            <>
                                <div
                                    className="form-group"
                                    data-testid={`${groupLabel
                                        .toLowerCase()
                                        .replaceAll(' ', '-')}-section`}
                                >
                                    <label className="!mb-1">{groupLabel}s</label>
                                    {field?.value?.length > 0 && (
                                        <table className="table table-sm !mb-1">
                                            <colgroup>
                                                <col width="5%" />
                                                <col width="10%" />
                                                <col width="30%" />
                                                <col width={isSecondaryImage ? '25%' : '45%'} />
                                                {isSecondaryImage && <col width="20%" />}
                                                <col width="10%" />
                                            </colgroup>

                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>Title</th>
                                                    <th>Description</th>
                                                    {isSecondaryImage && <th>Link Destination</th>}
                                                    <th className="!text-right">Remove</th>
                                                </tr>
                                            </thead>

                                            <Sortable
                                                tag="tbody"
                                                onChange={(order, sortable, evt) => {
                                                    const values = [...field.value]
                                                    const movedItem = values[evt.oldIndex]
                                                    const to = evt.newIndex
                                                    values.splice(evt.oldIndex, 1)
                                                    values.splice(to, 0, movedItem)
                                                    form.setFieldValue(field.name, values)
                                                }}
                                                options={{
                                                    animation: 100,
                                                    handle: '.handle',
                                                }}
                                            >
                                                {field.value.map((item, index) => (
                                                    <SortableRow
                                                        key={index}
                                                        data-id={index}
                                                        data-testid={`${group}_row-${index}`}
                                                    >
                                                        <td>
                                                            <span
                                                                className="handle"
                                                                data-testid={`${group}_item_${index}_slider-handle`}
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={faGripLines}
                                                                />
                                                            </span>
                                                        </td>
                                                        <td className="!text-center">
                                                            <ResourceIcon
                                                                type={group}
                                                                src={item.path}
                                                                testId={`${group}_item_${index}_image`}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Textarea
                                                                name={`categoryResources.${group}.${index}.title`}
                                                                label=""
                                                                placeholder="Title"
                                                                testId={`${group}_item_${index}_title`}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Textarea
                                                                name={`categoryResources.${group}.${index}.description`}
                                                                label=""
                                                                placeholder="Description"
                                                                testId={`${group}_item_${index}_description`}
                                                            />
                                                        </td>
                                                        {isSecondaryImage && (
                                                            <td>
                                                                <Textarea
                                                                    name={`categoryResources.${group}.${index}.destination`}
                                                                    label=""
                                                                    placeholder="Link Destination"
                                                                    testId={`${group}_item_${index}_link-destination`}
                                                                />
                                                            </td>
                                                        )}
                                                        <td className="!text-right">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => {
                                                                    remove(index, 1)
                                                                }}
                                                                data-testid={`${group}_item_${index}_remove`}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </td>
                                                    </SortableRow>
                                                ))}
                                            </Sortable>
                                        </table>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <File
                                                testId={`${group}s__input`}
                                                name={`resources_${groupLabel}`}
                                                placeholder={`Add a new ${groupLabel.toLowerCase()} to the product`}
                                                onSelectCallback={value => {
                                                    if (value.length > 0) {
                                                        const filename = last(value.split('/'))
                                                        push({
                                                            path: value,
                                                            title: decodeURI(filename),
                                                            description: '',
                                                        })
                                                    }
                                                }}
                                                onKeyPress={e => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()

                                                        if (e.target.value.length > 0) {
                                                            const filename = last(
                                                                e.target.value.split('/')
                                                            )

                                                            push({
                                                                path: e.target.value,
                                                                title: decodeURI(filename),
                                                                description: '',
                                                                destination: '',
                                                            })

                                                            e.target.value = ''
                                                        }
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </FieldArray>
                </>
            )}
        </Field>
    )
}

export default Resources
